import React from 'react';
import { Icon } from 'ksnm-common-ui/lib/Icon';
import { Justify } from 'ksnm-common-ui/lib/Table2/Table.interface';
import { ORDER } from 'ksnm-common-ui/lib/Table2/utils/TableRequest';
import { FILTER } from 'ksnm-common-ui/lib/Table2/utils/TableRequest/TableRequest.interface';
import type { ColumnInterface, DataSourceRow } from 'ksnm-common-ui/lib/Table2/Table.interface';

import { dataControlStore } from '@stores/dataControlStore';

import { Status } from '../Status';

import styles from '../DataControl.module.scss';

const onClick = (data: DataSourceRow) => {
  const { addBreadcrumbs, addPage } = dataControlStore;

  addBreadcrumbs([data.report_package_code_cm as string]);
  addPage([
    {
      controlType: 'packageLevel',
      reportPackageCodeCm: data.report_package_code_cm as string,
      filters: [
        [
          {
            name: 'report_package_code_cm',
            type: FILTER.EQ,
            values: [data.report_package_code_cm as string],
            filterIsInverted: false,
          },
        ],
      ],
    },
  ]);
};

export const columns: ColumnInterface[] = [
  {
    title: 'Пакет отчетности',
    key: 'report_package_code_cm',
    width: 250,
    render: ({ value }) => (
      <div className={styles.packageCell}>
        <div onClick={() => dataControlStore.setInfoDrawer({ packageCode: value as string })}>
          <Icon name="info" />
        </div>
        {value}
      </div>
    ),
    orderBy: {
      type: ORDER.ASC,
      order: 1,
      isNullsFirst: false,
    },
  },
  {
    title: 'Количество контролей (запущено | всего)',
    key: 'ctrl_amount',
    justify: Justify.CENTER,
    width: 350,
  },
  {
    title: 'Статус',
    key: 'status_out',
    width: 300,
    render: ({ data, value }) => (
      <Status status={data.status_type}>
        <div onClick={() => onClick(data)} className={styles.link}>
          {value}
        </div>
      </Status>
    ),
  },
  {
    title: 'Детализация статуса (успех | неудача)',
    key: 'status_amount',
    justify: Justify.CENTER,
    width: 350,
  },
  {
    title: 'Период выполнения КП',
    key: 'period_kp',
    width: 250,
    justify: Justify.CENTER,
  },
  {
    title: 'Дата и время выполнения КП',
    key: 'date_kp',
    width: 200,
    justify: Justify.CENTER,
  },
  {
    title: 'Пользователь',
    key: 'user_kp',
    width: 200,
  },
  {
    title: 'Количество запусков КП',
    key: 'exec_ctrl_qty',
    width: 200,
  },
  {
    title: 'Контролей настроено',
    key: 'ctrl_configured_amount',
    width: 200,
  },
  {
    key: 'status_type',
    hidden: true,
  },
];
